import { ChangeEvent, ReactElement, useCallback } from "react";
import { Input } from "../input/input";
import { InputProps } from "../input/input-props";

export const maskPhone = (event: ChangeEvent<HTMLInputElement>) => {
  event.currentTarget.maxLength = 15
  const { value } = event.currentTarget
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{4})/, '$1-$2')
}

export function InputPhone ({ onChange, ...props }: InputProps): ReactElement {
  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    event.currentTarget.value = maskPhone(event)
    if (onChange) onChange(event)
  }, [onChange])
  return <Input {...props} onChange={handleChange} />
}